export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M7.03 13.92H11.03V5L13.04 4.97V13.92H17.03L12.03 18.92Z\" /></svg>\n"